<template>
<div class="chapter">
<div class="inner_page">
<h1 class="GFP_Part_H1"><a id="_idTextAnchor005"></a>Autumn</h1>
<p class="GFP_Headnote"><span class="headnote_dropcap">A</span>utumn is a season of preparation on the farm: it’s the time we get the flock ready for the next year’s lambing, buy new lambs to replace elderly ewes, sell our ‘fat lambs’ at market, plough and drill our crops for next spring . . . and repair endless fences ready for winter.</p>
<div class="image_fleuron">
<img alt="fleuron" class="image_fleuron" src="image/fleuron.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter.vue?d73d98da